var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24"}},_vm.$listeners),[_c('path',{attrs:{"fill":"currentColor","d":"M12 7.25H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h1v4a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-4h3l5 4v-16zm3 7.6-2-1.6H4v-4h9l2-1.6zm6.5-3.6c0 1.71-.96 3.26-2.5 4v-8c1.53.75 2.5 2.3 2.5 4"}})])
}
var staticRenderFns = []

export default { render: render }